import type { ServiceAssignment } from '../types';

/**
 * Welche beauftragten Dokument-Positionen als offene Aufgabe in der
 * Aufgabenliste (TasksView) und auf der Dashboard-Kachel stehen.
 *
 * Betreiber-Entscheidung 20.09.2026: nur Vorankündigung, Unterlage für
 * spätere Arbeiten und Planungsphasen. SiGe-Plan, A+S-Plan, Einweisung und
 * Baustellenordnung haben im Projekt-Hub ihre eigene Kachel mit Stand und
 * wurden in der Liste als Dauerrauschen empfunden — ein Kontingent von drei
 * Einweisungen blieb etwa das ganze Projekt über als "offen" stehen.
 *
 * Liste und Kachel lesen BEIDE diese Konstante. Steht sie an zwei Stellen,
 * zeigt die Kachel früher oder später eine andere Zahl als die Liste dahinter.
 */
export const TASK_DOCUMENT_ASSIGNMENTS: readonly ServiceAssignment[] = ['vorank', 'unterlage', 'planning_general'];

export const isTaskDocumentAssignment = (assignment: string | undefined | null): boolean =>
    (TASK_DOCUMENT_ASSIGNMENTS as readonly string[]).includes(assignment || 'none');

const FIXED_LABELS: Partial<Record<ServiceAssignment, string>> = {
    vorank: 'Vorankündigung',
    unterlage: 'Unterlage für spätere Arbeiten',
};

/**
 * Beschriftung einer Dokument-Aufgabe. Vorankündigung und Unterlage sind
 * je Projekt genau eine Pflicht und heißen darum immer gleich. Planungsphasen
 * dagegen sind meist mehrere Positionen (LPH 1–3, LPH 5 …) — dort trägt der
 * Positionstitel die Unterscheidung, sonst hießen alle Zeilen gleich.
 */
export const taskDocumentLabel = (assignment: string, title?: string | null): string => {
    const fixed = FIXED_LABELS[assignment as ServiceAssignment];
    if (fixed) return fixed;
    const t = (title || '').trim();
    if (t) return t;
    return assignment === 'planning_general' ? 'Planungsphase' : assignment;
};
